// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__3zfcr","tab":"Tabs_tab__2TMR5"};